module.exports = {"id":"201046","name":"Riccardo Saponara","rating":"78","photo":"./data/images/photos/3/201046.png","club":{"name":"Fiorentina","logo":"./data/images/clubs/Fiorentina.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RiccardoSaponara0.json
// module id = 3602
// module chunks = 0